<template>
	<div class="home">
		<slide></slide>
		<div class="home-content">
			<div class="home-swipper-login">
				<!--      轮播图和登录-->
				<div class="home-swipper">
					<a-carousel :afterChange="swipperChanges" :dots="false" autoplay>
						<div
							class="home-picList"
							v-for="(item, index) in homePicList"
							:key="index"
							@click="$router.push(`/banner-news/detail/${item._id}`)"
						>
							<img :src="item.pic" alt="" />
							<div class="shadow">
								<p>{{ item.title }}</p>
							</div>
						</div>
					</a-carousel>
					<ul class="show_dot">
						<li
							v-for="(item, index) in homePicList"
							@click="changeDot"
							:key="index"
							:class="picIndex / 1 == index ? 'red_dot' : ''"
						></li>
					</ul>
				</div>

				<!-- 资讯展示 文明创建-->
				<div class="home-news zixun">
					<div class="home-news-right">
						<div class="home-news-top">
							<div class="home-news-top-title">资讯展示</div>
							<div class="home-news-top-more" @click="goto('civilization-creation')">
								更多
								<img src="../assets/img/home/arrow_gray@2x.png" alt="" />
							</div>
						</div>
						<div class="home-news-content" id="zixun">
							<div class="home-news-content-item" v-for="(item, i) in newchuangjiang" :key="i">
								<div v-if="item.href == ''" class="home-news-li" @click="gotochuangDetail(item)">
									<div>
										<p style="color: #cd3232; display: inline-block; font-size: 20px; margin-right: 5px">·</p>
										{{ item.title }}
									</div>
									<div class="home-news-content-date">
										{{ item.publishTime }}
									</div>
								</div>
								<a v-else class="home-news-li" target="_blank" :href="item.href">
									<div>
										<p style="color: #cd3232; display: inline-block; font-size: 20px; margin-right: 5px">·</p>
										{{ item.title }}
									</div>
									<div class="home-news-content-date">
										{{ item.publishTime }}
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>

				<!-- 登录 -->
				<!-- <div class="home-login-t" v-if="isLogin == false">
          <div class="login-text">
            <p class="login-text-top">亲爱的志愿者，欢迎登录</p>
            <p class="login-text-bottom">- 登录后查看个人相关信息 -</p>
          </div>
          <div class="home-input-wrapper">
            <div class="home-input">
              <a-input
                v-model="name"
                placeholder="手机号/邮箱/用户名/身份证"
                class="input-common"
                size="large"
              >
                <img slot="prefix" :src="image1" alt="" class="image" />
              </a-input>
              <a-input-password
                placeholder="请输入密码"
                v-model="password"
                class="input-common"
                size="large"
              >
                <img slot="prefix" :src="image2" alt="" class="image" />
              </a-input-password>
            </div>
            <div class="button submit" @click="login">登录</div>
            <div class="bottom">
              <a-checkbox
                @change="onChange"
                :checked="checked"
                class="bottom-top"
                >记住用户名</a-checkbox
              >
              <div class="bottom-button">
                <div class="left" @click="gotoOrgAdd">组织入驻</div>
                <div class="right">
                  <div @click="gotoForgot">忘记密码 |</div>
                  <div @click="gotoRegister">志愿者注册</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
				<!-- <div class="home-login-f" v-else>
          <div class="home-login-f-top">
            <img src="../assets/img/user/icon_headImage@2x.png" alt="" />

            <div class="home-login-f-top-center">
              {{ userName || "您好" }}，欢迎登录
            </div>
            <div class="home-login-f-top-right" @click="exit">退出</div>
          </div>
          <div class="home-login-f-center">
            <div class="home-login-f-center-item">
              我的信用时数：
              <p style="color: #cd3232">{{ creditduration || "0" }}小时</p>
            </div>
            <div class="home-login-f-center-item">
              我的荣誉时数：
              <p style="color: #cd3232">{{ hisduration || "0" }}小时</p>
            </div>
          </div>
          <div class="home-login-f-bottom" @click="gotoCenter">个人中心</div>
        </div> -->
			</div>

			<!--      理论学习，文明创建-->
			<div class="home-news">
				<div class="home-news-left">
					<div class="home-news-top">
						<div class="home-news-top-title">理论学习</div>
						<div class="home-news-top-more" @click="goto('new-era-theory')">
							更多
							<img src="../assets/img/home/arrow_gray@2x.png" alt="" />
						</div>
					</div>
					<div class="home-news-content">
						<!-- <img :src="lilunxuexi.pic" alt="" /> -->
						<div class="home-news-content-right" v-for="(item, index) in lilunxuexi" :key="index">
							<div v-if="item.href == ''" class="home-news-li" @click="gotoEraDetail(item)">
								<div class="home-news-content-title">
									<p style="color: #cd3232; display: inline-block; font-size: 20px; margin-right: 5px">·</p>
									{{ item.title }}
								</div>
								<div class="home-news-content-date">
									{{ item.publishTime }}
								</div>
							</div>
							<a v-else class="home-news-li" target="_blank" :href="item.href">
								<div class="home-news-content-title">
									<p style="color: #cd3232; display: inline-block; font-size: 20px; margin-right: 5px">·</p>
									{{ item.title }}
								</div>
								<div class="home-news-content-date">
									{{ item.publishTime }}
								</div>
							</a>
						</div>
					</div>
				</div>
				<div class="home-news-right">
					<div class="home-news-top">
						<div class="home-news-top-title">文明专栏</div>
						<div class="home-news-top-more" @click="goto('civilization-column')">
							更多
							<img src="../assets/img/home/arrow_gray@2x.png" alt="" />
						</div>
					</div>
					<div class="home-news-content">
						<div class="home-news-content-item" v-for="(item, index) in wenmingchuangjian" :key="index">
							<div v-if="item.href == ''" class="home-news-li" @click="gotoWenDetail(item)">
								<div>
									<p style="color: #cd3232; display: inline-block; font-size: 20px; margin-right: 5px">·</p>
									{{ item.title }}
								</div>
								<div class="home-news-content-date">
									{{ item.publishTime }}
								</div>
							</div>
							<a v-else class="home-news-li" target="_blank" :href="item.href">
								<div>
									<p style="color: #cd3232; display: inline-block; font-size: 20px; margin-right: 5px">·</p>
									{{ item.title }}
								</div>
								<div class="home-news-content-date">
									{{ item.publishTime }}
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="home-news-title">五大平台</div> -->
			<div id="home-news-top-title">五大平台</div>
			<div class="home-jump-pic">
				<img :src="item" alt="" v-for="(item, index) in homeJump" :key="index" @click="jumpPlateform(index)" />
			</div>
		</div>
		<!--  中间两个图  -->
		<div class="home-statistic">
			<div class="home-statistic-item">
				<img src="../assets/img/home/home_number_1@2x.png" alt="" />
				<div class="home-statistic-item-right">
					<p class="home-statistic-item-right-top">
						{{ onlineCountnum }}
					</p>
					<p class="home-statistic-item-right-bottom">今日已在岗志愿者</p>
				</div>
				<div class="home-statistic-item-right-r"></div>
			</div>
			<div class="home-statistic-item">
				<img src="../assets/img/home/home_number_2@2x.png" alt="" />

				<div class="home-statistic-item-right">
					<p class="home-statistic-item-right-top">
						{{ summaryData.person }}
					</p>
					<p class="home-statistic-item-right-bottom">注册志愿者</p>
				</div>
				<div class="home-statistic-item-right-r"></div>
			</div>
			<div class="home-statistic-item">
				<img src="../assets/img/home/home_number_3@2x.png" alt="" />

				<div class="home-statistic-item-right">
					<p class="home-statistic-item-right-top">
						{{ statisticsNum.deptcount }}
					</p>
					<p class="home-statistic-item-right-bottom">组织</p>
				</div>
				<div class="home-statistic-item-right-r"></div>
			</div>
			<div class="home-statistic-item" style="width: auto">
				<img src="../assets/img/home/home_number_4@2x.png" alt="" />

				<div class="home-statistic-item-right">
					<p class="home-statistic-item-right-top">
						{{ summaryDataTime }}
					</p>
					<p class="home-statistic-item-right-bottom">累计服务时长</p>
				</div>
				<div class="home-statistic-item-right-r"></div>
			</div>
			<div class="home-statistic-item">
				<img src="../assets/img/home/home_number_5@2x.png" alt="" />
				<div class="home-statistic-item-right">
					<p class="home-statistic-item-right-top">
						{{ totalDevelopActivityNum }}
					</p>
					<p class="home-statistic-item-right-bottom">发布活动数</p>
				</div>
			</div>
		</div>

		<!--    最新招募-->
		<div class="home-content">
			<div class="recruit-content">
				<div class="recruit-top">
					<div class="recruit-top-title">最新招募</div>
					<div class="recruit-top-more">
						更多
						<img src="../assets/img/home/arrow_gray@2x.png" alt="" />
					</div>
				</div>
				<div class="recruit-list">
					<div
						class="recruit-list-item"
						v-for="(item, index) in recruitList.slice(0, 6)"
						:key="index"
						@click="toDetail(item)"
					>
						<div class="recruit-list-item-image">
							<img :src="item.thumb" alt="" />
						</div>
						<div class="recruit-list-item-title">{{ item.title }}</div>
						<div class="recruit-list-item-address">
							<img src="../assets/img/common/icon_dizhi@2x.png" alt="" />{{ item.detailaddress }}
						</div>
						<div class="recruit-list-item-bottom">
							<div class="r-left" v-if="item.actStatus == 1">
								剩余
								<p style="color: #5e89de">{{ item.lastTime }}</p>
								截止
							</div>
							<div class="r-left" v-if="item.actStatus == 0">
								<p style="color: #5e89de">{{ item.lastTime }}</p>
							</div>
							<div class="r-left" v-if="item.actStatus == 2">
								<p style="color: #727384">{{ item.lastTime }}</p>
							</div>

							<div class="r-right">
								<img src="../assets/img/home/icon_renshu@2x.png" alt="" />{{ item.signup_people }}/{{
									item.recruit_people
								}}人
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--    志愿排行修改-->
		<div class="home-content1">
			<div class="voluntary-left">
				<div class="voluntary-title">
					<span class="voluntary-span1">志愿者排行</span>
				</div>
				<table>
					<tr class="tr1">
						<td>
							<div class="tdC">名次</div>
						</td>
						<td>排名</td>
						<td>累计服务时长</td>
					</tr>
					<tr class="tr2 voluntary-ranking-list-item" v-for="(item, index) in volunteerRankList2" :key="item.id">
						<td>
							<div class="tdC vrli-left">{{ index + 1 }}</div>
						</td>
						<td>{{ item.name }}</td>
						<td>{{ item.duration }}小时</td>
					</tr>
				</table>
			</div>
			<div class="voluntary-right">
				<div class="voluntary-title">
					<span class="voluntary-span2">志愿团队排行</span>
				</div>
				<table>
					<tr class="tr1">
						<td>
							<div class="tdC">名次</div>
						</td>
						<td>排名</td>
						<td>累计服务时长</td>
					</tr>
					<tr class="tr2 voluntary-ranking-list-item" v-for="(item, index) in volunteerRankList" :key="item.id">
						<td>
							<div class="tdC vrli-left">{{ index + 1 }}</div>
						</td>
						<td>{{ item.name }}</td>
						<td>{{ item.value.toFixed(1) }}小时</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Slide from '@/components/common/Slide'
import dayjs from 'dayjs'
import moment from 'moment'

export default {
	components: {
		Slide
	},
	data() {
		return {
			homePicList: [],
			picIndex: 0,
			image1: require('@/assets/img/home/login_1@2x.png'),
			image2: require('@/assets/img/home/login_2@2x.png'),
			checked: false,
			name: '',
			password: '',
			isLogin: false,
			lilunxuexi: {},
			wenmingchuangjian: [],
			newchuangjiang: [],
			homeJump: [
				require('@/assets/img/home/home-jump1.png'),
				require('@/assets/img/home/home-jump2.png'),
				require('@/assets/img/home/home-jump3.png'),
				require('@/assets/img/home/home-jump4.png'),
				require('@/assets/img/home/home-jump5.png')
			],
			recruitList: [],
			volunteerRankList: [],
			volunteerRankList2: [],
			userName: '',
			sex: '',
			creditduration: '0',
			hisduration: '0',
			siteId: process.env.VUE_APP_siteId, //'1637056442198bfbe7eaff903420a996db1b9c5fc22cb',
			deptId: process.env.VUE_APP_deptId, //"1476084112357207a08eba11e682992c56dcba85b9",
			orginizeTimeVot: [],
			volunteerTimeVot: [],
			votingType: 1,
			statisticsNum: {},

			// 志愿者人数
			summaryData: {},
			summaryDataTime: {},
			// 志愿活动数
			totalDevelopActivityNum: '0',
			onlineCountnum: '0',
			servetimer: 0
		}
	},

	created() {
		const userName = localStorage.getItem('jz_user')
		if (userName) {
			// console.log(userName);
			this.name = userName
			this.checked = true
		}
		const zyzid = localStorage.getItem('jz_vol_zyzid')
		if (zyzid) {
			this.isLogin = true
		}
	},
	mounted() {
		this.getUserInfo()
		this.getSwipperList()
		this.getSecondType()
		// this.getCultureList();
		this.getVolunteerVoting()
		this.getOrginizeVoting()
		this.getRecruitList()
		this.getStatisticsNum()
	},
	methods: {
		toDetail(item) {
			if (this.isLogin == false) {
				this.$message.info('请先登录账号')
				return
			}
			this.$router.push(`/voluntary-activites/detail/${item.id}`)
		},

		swipperChanges(e) {
			console.log(e)
			this.picIndex = e
		},

		changeDot(e) {},
		//五大平台
		jumpPlateform(index) {
			if (index == 0) {
				this.$router.push('/five-plateform-theory')
			} else if (index == 1) {
				this.$router.push('/five-plateform-education')
			} else if (index == 2) {
				this.$router.push('/five-plateform-culture')
			} else if (index == 3) {
				this.$router.push('/five-plateform-technology')
			} else if (index == 4) {
				this.$router.push('/five-plateform-healthy')
			}
		},
		//获取统计数据
		getStatisticsNum() {
			// this.$api.vmsapi.statisticsNumList({ deptId: this.deptId }).then((res) => {
			// 	if (res.errCode == '0000') {
			// 		let timer = parseInt(res.data.hisduration * 1 + res.data.creditduration * 1)
			// 		this.servetimer = timer
			// 		this.statisticsNum = res.data
			// 	}
			// })
			// this.$api.vmsapi.signinfoNumList({ deptIds: this.deptId }).then((res) => {
			// 	if (res.errCode == '0000') {
			// 		this.onlineCountnum = res.data.depts[0].onlineCount
			// 	}
			// })
			// 今日实时在岗人数
			this.$api.vmsapi.signinfo({ deptIds: this.deptId }).then((res) => {
				// console.log('onlineCountnum', res.depts[0].onlineCount)
				this.onlineCountnum = res.depts[0].onlineCount
			})
			// 注册志愿者数
			this.$api.vmsapi.summaryData({ deptId: process.env.VUE_APP_deptId }).then((res) => {
				console.log('summaryData', res)
				this.summaryData = res
				this.summaryDataTime = parseInt(res.value)
			})
			// 志愿者组织数
			this.$api.vmsapi.zyzOrgNumList({ deptid: process.env.VUE_APP_deptId }).then((res) => {
				this.statisticsNum = res
				// this.onlineCountnum = res.todaycount
			})
			// 获取志愿活动数
			this.$api.vmsapi.totalDevelopActivityNum({ deptId: process.env.VUE_APP_deptId }).then((res) => {
				console.log('发布活动数', res)
				this.totalDevelopActivityNum = res
			})
		},
		//获取招募列表
		getRecruitList() {
			this.$api.vmsapi
				.recruitList({
					page: 1,
					rows: 6,
					ordertype: 1,
					isUnNeedTotal: true,
					city: process.env.VUE_APP_deptId, //"1476084112357207a08eba11e682992c56dcba85b9",
					status: 2
				})
				.then((res) => {
					console.log('最新招募', res)
					res.data.forEach((element) => {
						let nowtime = new Date().getTime()
						let lastTime = ''
						let actStatus = 0

						// item.remainingTime=dayjs(item.recruit_finish_time-item.recruit_start_time).format('DD'+'天'+'HH'+'小时')

						if (element.recruit_start_time > nowtime) {
							lastTime = '即将开始'
						} else if (element.recruit_start_time < nowtime && element.recruit_finish_time > nowtime) {
							lastTime = dayjs(element.recruit_finish_time).format('DD' + '天' + 'HH' + '小时')
							actStatus = 1
						} else if (element.recruit_finish_time < nowtime) {
							lastTime = '已截止'
							actStatus = 2
						}
						element.lastTime = lastTime
						element.actStatus = actStatus
					})
					this.recruitList = res.data
				})
		},
		//获取组织时长排行
		getOrginizeVoting() {
			this.$api.xsdapi
				.orginizeTimeVoting({
					deptId: process.env.VUE_APP_deptId, //"1476084112357207a08eba11e682992c56dcba85b9",
					page: 1,
					rows: 10
				})
				.then((res) => {
					// console.log(res, '组织者')
					if (res) {
						console.log('orginizeTimeVoting', res)
						// this.volunteerRankList = [...this.orginizeTimeVot]
						// console.log(this.volunteerRankList)
						this.volunteerRankList = res
					}
				})
		},
		//获取志愿者时长排行
		getVolunteerVoting() {
			this.$api.vmsapi
				.volunteerTimeVoting({
					deptid: process.env.VUE_APP_deptId, //"1476084112357207a08eba11e682992c56dcba85b9",
					page: 1,
					rows: 10
				})
				.then((res) => {
					console.log(res, '志愿者')
					if (res) {
						this.volunteerTimeVot = res
						this.volunteerRankList2 = [...this.volunteerTimeVot]
						console.log('0101', this.volunteerRankList2)
					}
				})
		},
		getSecondType() {
			this.$api.xsdapi
				.secondType({
					siteId: process.env.VUE_APP_siteId, //'1637056442198bfbe7eaff903420a996db1b9c5fc22cb',
					typeCode: 'lecture_class'
				})
				.then((res) => {
					console.log(res, 777)
					if (res && res.length > 0) {
						for (let i = 0; i < res.length; i++) {
							const element = res[i]
							if (element.secondTypeName === '新时代理论') {
								const params = {
									page: 1,
									pageSize: 4,
									type: 'lecture_class',
									siteId: element.siteId,
									secondType: element._id
								}

								this.getNewsList(params, 1)
							} else if (element.secondTypeName === '文明专栏') {
								const params = {
									page: 1,
									pageSize: 4,
									type: 'lecture_class',
									siteId: element.siteId,
									secondType: element._id
								}
								this.getNewsList(params, 2)
							} else if (element.secondTypeName === '文明创建') {
								const params = {
									page: 1,
									pageSize: 5,
									type: 'lecture_class',
									siteId: element.siteId,
									// siteId: process.env.VUE_APP_siteId_wm,
									secondType: element._id
								}
								this.getNewsList(params, 3)
							}
						}
					}
				})
		},
		getNewsList(params, type) {
			this.$api.xsdapi.newsList(params).then((res) => {
				if (type === 1 && res.data.length > 0) {
					// this.lilunxuexi.publishTime &&
					//   (this.lilunxuexi.publishTime = moment(
					//     this.lilunxuexi.publishTime
					//   ).format("YYYY-MM-DD"));
					// this.lilunxuexi = res.data[0];
					res.data.forEach((item) => {
						if (item.publishTime) item.publishTime = moment(item.publishTime).format('YYYY-MM-DD')
					})
					this.lilunxuexi = res.data
				} else if (type === 2) {
					res.data.forEach((item) => {
						if (item.publishTime) item.publishTime = moment(item.publishTime).format('YYYY-MM-DD')
					})
					this.wenmingchuangjian = res.data
				} else {
					res.data.forEach((item) => {
						if (item.publishTime) item.publishTime = moment(item.publishTime).format('YYYY-MM-DD')
					})
					this.newchuangjiang = res.data
				}
			})
		},
		//轮播图接口
		getSwipperList() {
			this.$api.xsdapi.swipperList({ siteId: this.siteId }).then((res) => {
				console.log(res, 123)
				this.homePicList = res
				console.log(this.homePicList, 888)
			})
		},
		exit() {
			;(this.isLogin = false),
				(this.userName = ''),
				(this.sex = ''),
				(this.creditduration = '0'),
				(this.hisduration = '0')
			localStorage.removeItem('jz_vol_token')
			localStorage.removeItem('jz_vol_zyzid')

			// localStorage.clear()
		},
		getUserInfo() {
			const zyzid = localStorage.getItem('jz_vol_zyzid')
			if (!zyzid) return
			this.$api.vmsapi
				.vmsInfo({ zyzid: zyzid })
				.then((res) => {
					res.data.headimage && (this.headImage = res.data.headimage)
					this.userName = res.data.nickname || res.data.name
					this.sex =
						res.sex == '2'
							? require('@/assets/img/user/icon_sex_2@2x.png')
							: require('@/assets/img/user/icon_sex_1@2x.png')
					this.hours = parseFloat(Number(res.data.creditduration) + Number(res.data.hisduration)).toFixed(2)
					this.creditduration = res.data.creditduration
					this.hisduration = res.data.hisduration
					this.isLogin = true
				})
				.catch(() => {
					this.isLogin = false
				})
		},

		goAbout() {
			this.$router.push({ name: 'about' })
		},
		goto(name) {
			this.$router.push({ name: name })
		},
		login() {
			if (!this.name) {
				this.$message.error('请输入您的证件号')
				return
			}
			if (!this.password) {
				this.$message.error('请输入密码')
				return
			}

			if (this.loading) return
			this.$api.vmsapi
				.login({ username: this.name, password: this.password })
				.then((res) => {
					localStorage.setItem('jz_vol_token', res.token)
					this.userIdRequest(res.token)
				})
				.catch(() => {
					this.loading = false
				})
		},
		userIdRequest(token) {
			this.$api.vmsapi
				.getUserId(token)
				.then((res) => {
					localStorage.setItem('jz_vol_zyzid', res.userId)
					if (this.checked) {
						localStorage.setItem('jz_user', this.name)
					} else {
						localStorage.removeItem('jz_user')
					}
					this.getUserInfo()
					this.isLogin = true
				})
				.finally(() => {
					this.loading = false
				})
		},
		gotoOrgAdd() {
			this.$router.push({ name: 'orgAdd' })
		},
		gotoForgot() {
			this.$router.push({ name: 'forgot1' })
		},
		gotoRegister() {
			this.$router.push({ name: 'register' })
		},
		onChange() {
			this.checked = !this.checked
		},
		gotoCenter() {
			this.$router.push({ name: 'time' })
		},
		gotoEraDetail(item) {
			if (item._id) {
				this.$router.push(`/new-era-theory/detail/${item._id}`)
			}
		},
		gotoWenDetail(item) {
			this.$router.push(`/civilization-column/detail/${item._id}`)
		},
		gotochuangDetail(item) {
			this.$router.push(`/civilization-creation/detail/${item._id}`)
		}
	}
}
</script>

<style lang="scss" scoped>
.home-content1 {
	overflow: hidden;
	width: 1200px;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	height: 650px;
	background: #f6f6f6;
	padding: 10px 100px;

	.voluntary-title {
		font-size: 20px;
		height: 36px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 36px;
		border-bottom: 1px solid #e1e2e3;
		text-align: left;
		margin-right: 100px;
		margin-top: 10px;
		margin-bottom: 15px;

		.voluntary-span1 {
			display: inline-block;
			line-height: 32px;
			border-bottom: 3px solid #cd3232;
		}
		.voluntary-span2 {
			display: inline-block;
			line-height: 32px;
			border-bottom: 3px solid #cd3232;
		}
	}

	.voluntary-left {
		float: left;
	}
	.voluntary-right {
		float: right;
	}
	table {
		width: 450px;
		font-size: 18px;
		line-height: 50px;

		tr {
			width: 100%;
			td {
				text-align: center;
				width: 90px;
			}
			.tdC {
				float: left;
				width: 40px;
			}
		}
		.tr1 {
			color: #de0617;
		}
		td + td {
			text-align: left;
			width: 180px;
			overflow: hidden;
			text-overflow: ellipsis;
			// display: -webkit-box;
			display: -webkit-inline-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
		}
		td + td + td {
			width: 180px;
			text-align: center;
		}
	}

	.voluntary-ranking-list-item:nth-child(2) {
		.vrli-left {
			display: none;
		}

		background-image: url('../assets/img/home/rank1.png');
		background-repeat: no-repeat;
		background-position: left center;
	}
	.voluntary-ranking-list-item:nth-child(3) {
		.vrli-left {
			display: none;
		}

		background-image: url('../assets/img/home/rank2.png');
		background-repeat: no-repeat;
		background-position: left center;
	}
	.voluntary-ranking-list-item:nth-child(4) {
		.vrli-left {
			display: none;
		}

		background-image: url('../assets/img/home/rank3.png');
		background-repeat: no-repeat;
		background-position: left center;
	}
}

#home-news-top-title {
	font-size: 20px;
	width: 80px;
	height: 30px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 15px;
	border-bottom: 3px solid #cd3232;
	margin-top: 25px;
}

.home-news.zixun {
	margin-top: 0;
}
#zixun {
	height: 310px;
}
.home {
	background: white;
	height: 100%;
	width: 100%;
	padding-top: 1px;
}
.home-picList {
	position: relative;
	img {
		width: 580px;
		height: 360px;
	}
	.shadow {
		position: absolute;
		width: 100%;
		text-align: left;
		text-indent: 10px;
		background: rgba(0, 0, 0, 0);
		font-size: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		p {
			margin-top: 320px;
			height: 40px;
			line-height: 40px;
			font-size: 16px;
			color: #ffffff;
			background: rgba(0, 0, 0, 0.5);
		}
	}
	.shadow_1 {
		position: absolute;
		width: 100%;
		text-align: left;
		text-indent: 10px;
		background: rgba(0, 0, 0, 0);
		font-size: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		div {
			margin-top: 320px;
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			color: #ffffff;
		}
	}
}
.home-content {
	width: 1200px;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	padding-bottom: 20px;
}
.home-swipper-login {
	margin-top: 36px;
	padding-top: 8px;
	display: flex;
	justify-content: space-between;
	.home-swipper {
		width: 580px;
		height: 360px;
		margin-right: 14px;
		// border:2px solid #eeeeee;
		position: relative;
		.show_dot {
			position: absolute;
			width: 100%;
			display: flex;
			justify-content: flex-end;
			height: auto;
			right: 10px;
			bottom: 10px;
			// background-color: #fff;
			li {
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background-color: #fff;
				margin-left: 10px;
			}
			.red_dot {
				background-color: red;
			}
		}
	}
	.home-login-t {
		//background-image: url("../assets/img/home/home-login-background.png");
		background: #ffffff;
		width: 386px;
		height: 360px;
		position: relative;
		border: 2px solid #eeeeee;
		border-radius: 10px;
		.login-text {
			position: relative;
			height: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: black;
			margin-top: 28px;
			.login-text-top {
				position: absolute;
				width: 220px;
				font-size: 20px;
				left: 50%;
				transform: translateX(-50%);
			}
			.login-text-bottom {
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				margin-top: 37px;
				width: 181px;
				font-size: 14px;
			}
		}
		.home-input-wrapper {
			left: 50%;
			transform: translateX(-50%);
			margin-top: 80px;
			position: absolute;
			.home-input {
				display: flex;
				flex-direction: column;
				.input-common {
					width: 258px;
					height: 35px;
					background: #ffffff;
					border-radius: 2px;
					margin-bottom: 20px;
					.image {
						width: 20px;
						height: 20px;
					}
				}
			}
		}
		.submit {
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 258px;
			height: 35px;
			background: #cd3232;
			border-radius: 2px;
			color: white;
		}
		.bottom {
			display: flex;
			flex-direction: column;
			color: black;
			.bottom-top {
				margin-top: 10px;
				text-align: left;
				color: black;
			}
			.bottom-button {
				margin-top: 10px;

				display: flex;
				flex-direction: row;
				justify-content: space-between;
				.left {
					cursor: pointer;
				}
				.right {
					cursor: pointer;
					display: flex;
					flex-direction: row;
				}
			}
		}
	}
	.home-login-f {
		border: 2px solid #eee;
		border-radius: 5px;
		width: 386px;
		height: 360px;
		.home-login-f-top {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding: 26px;
			img {
				width: 73px;
				height: 73px;
				border-radius: 50%;
			}
			.home-login-f-top-center {
				height: 14px;
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #000000;
				line-height: 14px;
			}
			.home-login-f-top-right {
				cursor: pointer;
				height: 20px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #559cfc;
				line-height: 20px;
			}
		}
		.home-login-f-center {
			margin-top: 28px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			height: 25px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 17px;
			.home-login-f-center-item {
				display: flex;
				flex-direction: row;
				justify-content: center;
				margin-bottom: 22px;
			}
		}
		.home-login-f-bottom {
			cursor: pointer;
			margin-top: 70px;
			width: 150px;
			height: 40px;
			border-radius: 2px;
			border: 1px solid #cd3232;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-left: 117px;
			color: #cd3232;
		}
	}
}
.home-news {
	margin-top: 50px;
	display: flex;
	flex-direction: row;

	.home-news-top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		height: 30px;
		width: 580px;
		border-bottom: 1px solid #e1e2e3;

		.home-news-top-title {
			font-size: 20px;
			height: 30px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #222222;
			line-height: 15px;
			border-bottom: 3px solid #cd3232;
		}
		.home-news-top-more {
			cursor: pointer;
			height: 20px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 20px;
			display: flex;
			flex-direction: row;
			align-items: center;
			img {
				width: 6px;
				margin-left: 10px;
				height: 12px;
			}
		}
	}
	.home-news-content {
		height: 194px;
		// background: #f6f6f6;
	}
	.home-news-left {
		width: 580px;
		height: 244px;
		margin-right: 40px;

		.home-news-content {
			width: 580px;
			padding: 22px 0;
			display: flex;
			flex-direction: column;

			.home-news-content-right {
				width: 100%;

				.home-news-li {
					display: flex;
					width: 100%;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1px dashed #d4d2d2;
					cursor: pointer;
					line-height: 38px;
					.home-news-content-title {
						// height: 31px;
						line-height: 38px;
						font-size: 14px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #222222;
						width: 70%;
						// line-height: 28px;
						text-align: left;
						//  多余字体省略
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}
					.home-news-content-date {
						text-align: left;
						height: 20px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
						line-height: 20px;
					}
				}
				// .home-news-content-center {
				//   text-align: left;
				//   height: 100px;
				//   font-size: 14px;
				//   font-family: PingFangSC-Regular, PingFang SC;
				//   font-weight: 400;
				//   color: #222222;
				//   line-height: 24px;
				//   //  多余字体省略
				//   overflow: hidden;
				//   text-overflow: ellipsis;
				//   display: -webkit-box;
				//   -webkit-box-orient: vertical;
				//   -webkit-line-clamp: 4;
				// }
			}
		}
	}
	.home-news-right {
		width: 580;
		// width: calc(100% - 620px);
		height: 244px;
		.home-news-content {
			width: 100%;
			padding: 22px 0;
			.home-news-content-item {
				width: 580;
				border-bottom: 1px dashed #d4d2d2;
				.home-news-li {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #222222;
					line-height: 38px;
					cursor: pointer;
					width: 100%;
					// display: block;
					div {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}
	}
}
.home-jump-pic {
	margin-top: 30px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
.home-statistic {
	background-image: url('../assets/img/home/statistics-background1.png');
	background-size: 100% 100%;
	height: 260px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	.home-statistic-item {
		display: flex;
		flex-direction: row;
		width: 220px;
		margin-right: 20px;
		img {
			width: 36px;
			height: 36px;
			margin-right: 20px;
		}
		.home-statistic-item-right {
			width: 200px;
			display: flex;
			flex-direction: column;

			.home-statistic-item-right-top {
				text-align: left;
				height: 20px;
				font-size: 36px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #cd3232;
				line-height: 20px;
			}
			.home-statistic-item-right-bottom {
				text-align: left;
				margin-top: 20px;
				height: 14px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 14px;
			}
		}
		.home-statistic-item-right-r {
			content: '';
			width: 1px;
			height: 40px;
			background: #969798;
		}
	}
}

.recruit-content {
	margin-top: 30px;

	.recruit-top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		.recruit-top-title {
			font-size: 20px;
			height: 30px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #222222;
			line-height: 15px;
			border-bottom: 3px solid #cd3232;
		}
		.recruit-top-more {
			height: 20px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 20px;
			display: flex;
			flex-direction: row;
			align-items: center;
			img {
				width: 6px;
				height: 12px;
			}
		}
	}
	.recruit-list {
		margin-top: 30px;
		display: grid;
		grid-template-columns: 400px 400px 400px;
		grid-template-rows: 424px 424px;
		.recruit-list-item {
			padding-top: 10px;
			.recruit-list-item-image {
				width: 385px;
				height: 265px;
				display: table-cell;
				vertical-align: middle;
				//
				//display: flex;
				//align-items: center;
				//justify-content: center;
				img {
					//margin-top: 20px;
					//height: 100%;
					max-width: 100%;
					max-height: 100%;
					display: block;
					margin: auto;
				}
			}
			height: 410px;
			border: 2px solid #f3f2f2;
			margin-right: 15px;
			border-radius: 10px;
			.recruit-list-item-title {
				padding: 0 10px;
				margin-top: 10px;
				width: 380px;
				text-align: left;
				overflow: hidden; //超出文本隐藏
				text-overflow: ellipsis; //溢出用省略号显示
				white-space: nowrap; //溢出不换行
				height: 20px;
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 20px;
			}
			.recruit-list-item-address {
				padding: 0 10px;
				//display: flex;
				//flex-direction: row;
				//align-items: center;
				text-align: left;
				img {
					width: 11px;
					height: 13px;
					margin-top: 2px;
					margin-right: 4px;
				}
				margin-top: 9px;
				display: flex;
				flex-direction: row;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 20px;
			}
			.recruit-list-item-bottom {
				padding: 0 10px;

				margin-top: 23px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-direction: row;
				width: 380px;
				height: 60px;
				border-top: 2px solid #f3f2f2;

				.r-left {
					display: flex;
					flex-direction: row;
					height: 20px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: 20px;
				}
				.r-right {
					display: flex;
					flex-direction: row;
					align-items: center;
					img {
						width: 11px;
						height: 13px;
					}
					height: 20px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #cd3232;
					line-height: 20px;
				}
			}
		}
	}
}
</style>
